import { render, staticRenderFns } from "./OrderFilingTax.vue?vue&type=template&id=0a30fcd3&scoped=true"
import script from "./OrderFilingTax.vue?vue&type=script&lang=js"
export * from "./OrderFilingTax.vue?vue&type=script&lang=js"
import style0 from "./OrderFilingTax.vue?vue&type=style&index=0&id=0a30fcd3&prod&scoped=true&lang=css"
import style1 from "./OrderFilingTax.vue?vue&type=style&index=1&id=0a30fcd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30fcd3",
  null
  
)

export default component.exports